import React, { useContext } from "react";
import Box from "@mui/material/Box";
import Alert from "@mui/material/Alert";
import IconButton from "@mui/material/IconButton";
import Collapse from "@mui/material/Collapse";
import Button from "@mui/material/Button";
import CloseIcon from "@mui/icons-material/Close";
import { Typography } from "@mui/material";
import { UserContext } from "../../context/userContext";
import { UserLoginInfo } from "../../types/context";
import { ROLE_USER_MEMBER } from "../../model";

export default function NoProductMessage() {
  const [open, setOpen] = React.useState(true);
  const { userInfo } = useContext(UserContext) as UserLoginInfo;
  return (
    <Box sx={{ width: "100%" }}>
      <Collapse in={open}>
        <Alert
          // severity="warning"
          severity="info"
          action={
            <IconButton
              aria-label="close"
              // color="inherit"
              size="small"
              onClick={() => {
                setOpen(false);
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          }
          sx={{ mb: 2 }}
        >
          <Typography style={{ fontSize: 13, fontWeight: 300 }}>
            No Products found for your organisation.
            {userInfo?.userDetails?.userRole != ROLE_USER_MEMBER ? (
              <>
                {" "}
                Please Go to <b>"Manage Accounts {">"} Add Account"</b>.
              </>
            ) : (
              <>
                {" "}
                Please contact <b>"Admin"</b>.
              </>
            )}
          </Typography>
        </Alert>
      </Collapse>
      {/* <Button
                disabled={open}
                variant="outlined"
                onClick={() => {
                    setOpen(true);
                }}
            >
                Re-open
            </Button> */}
    </Box>
  );
}
